
import WidgetMixins from '../../../../mixins/WidgetMixins';
import DialogValidationMixin from '../../../../mixins/DialogValidationMixin';
import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import { IPayments, PayloadState } from '@/types/types';
const paymentDetailsModule = namespace('payments');
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { numeric, required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Field is required',
});
extend('numeric', {
  ...numeric,
  message: 'Invalid mobile money number provided',
});
@Component({
  name: 'AddPaymentMethod',
  components: {
    ValidationProvider,
    ValidationObserver,
    SkeletonPreloader: loadWidget('widgets/SkeletonPreloader'),
  },
})
export default class GetLink extends mixins(
  WidgetMixins,
  DialogValidationMixin
) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @paymentDetailsModule.Getter('getResetFormValues') resetFormValues!: Pick<
    IPayments,
    'amount'
  >;

  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading
  @Prop({ default: false }) link!: string;

  /* Email and a channel chooser used to live here. Neither reached the
     server: CreateTopUpDto carries neither field, the email is taken from
     the authenticated user, and collection is always mobile money. */
  payment: Pick<IPayments, 'amount'> = {
    amount: null,
  };

  /* clearing validation on reopen is handled by DialogValidationMixin;
     the amount itself is cleared here so a stale figure is never resubmitted */
  @Watch('state')
  onDialogOpen(isOpen: boolean): void {
    if (isOpen) {
      this.payment = { amount: null };
    }
  }

  @Watch('resetFormState')
  onFormChange(payload: boolean): void {
    if (payload) {
      this.payment = { amount: null };
    } else this.$store.dispatch('resetFormValues', false, { root: true });
  }

  @Emit('payment')
  addPayment(): Pick<IPayments, 'amount'> {
    return this.payment;
  }

  @Emit('actions')
  close(): PayloadState {
    return {
      idx: 'payment',
      state: false,
    };
  }
}
